module.exports = __webpack_public_path__ + "static/a-spy-among-friends-e83ada814d8631d10661289ab03395bb.jpg";